module.exports = __webpack_public_path__ + "static/media/loader.bb15af0d.jpeg";